<template>
 <v-row no-gutters>
    <v-col>
        <v-toolbar dense :elevation="0" class="rpd-toolbar mb-2">
            <div class="text-primary-700" style="font-weight: 700; display: grid;">
                <span style="font-size: large">Enquiries</span>  
                <span style="margin-top:-10px">
                <a href="https://rp-database.com/docs/features/enquiries" target="_blank" rel="noopener noreferrer" class="title-docs" style="font-size: small;">Open Docs</a>
                </span>
            </div>
                    <v-btn-toggle class="mx-2"
                                    v-model="tableType"
                                    tile
                                    group
                                    mandatory

                    >
                        <v-btn value="company">
                            By Company
                        </v-btn>

                        <v-btn value="property">
                            By Property
                        </v-btn>
                </v-btn-toggle>
            <!-- <div class="flex-grow-1"></div> -->
            <!-- <v-btn color="primary float-right" outlined @click="$refs.addEnquiriesDialog.showDialog()">Manage Enquiries</v-btn> -->
            <v-spacer></v-spacer>
            <v-row class="px-0 py-4" style="flex-grow: 100000; max-width: 1000px;" align="center">
                <v-spacer></v-spacer>
                <v-checkbox
                    v-if="tableType === 'property'"
                    v-model="hideWithdrawn"
                    label="Hide Withdrawn/Completed"
                    hide-details
                    class="mr-4"
                    @change="getEnquiries()"
                ></v-checkbox>
                <!-- <div style="width:300px" class="mr-4">
                    
                    
                </div> -->

                <v-btn v-if="tableType === 'property'" class="mr-2 elevation-0" height="40" color="primary"  @click="exportEnquiries" :loading="isExporting">
                    <span class="mr-2">Export</span>
                    <v-icon size="20">mdi-file-excel</v-icon>
                </v-btn>
                <v-btn v-else class="mr-2 elevation-0" height="40" color="primary" @click="exportTotals" :loading="isExporting">
                    <span class="mr-2">Export</span>
                    <v-icon size="20">mdi-file-excel</v-icon>
                </v-btn>

                <v-menu
                    v-model="filtersMenu"
                    :close-on-content-click="false"
                    :width="500"
                    offset-y
                    >
                    <template v-slot:activator="{ on }">
                        <v-badge class="mr-4" color="red" style="float:right" overlap bordered :value="filtersActive">
                        <!-- <v-badge class="mr-4 ml-2 mt-1" style="float:right" overlap bordered :content="filtersCount" :value="filtersCount > 0"> -->
                        <v-btn height="40" outlined v-on="on" class="mt-0">
                            <v-icon>mdi-table-search</v-icon>
                            Filters
                        </v-btn>
                        </v-badge>
                    </template>
                    <v-card style="width: 400px;">
                        <v-card-title>
                        <h4 class="text-primary-700">Filters</h4>
                        <v-spacer></v-spacer>
                        <v-btn class="ml-2" outlined @click="resetFilters">
                            Reset
                        </v-btn>
                        </v-card-title>
                        <v-divider class="mx-2"></v-divider>
                        <v-card-text class="rpd-filter-card-text pb-8">
                                <v-row>
                                    <v-col cols="12">
                                        <v-menu offset-y persistent permanent content-class="mt-2" :close-on-content-click="false">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    v-model="dateRangeText"
                                                    append-icon="mdi-calendar"
                                                    class="rpd-datepicker-text"
                                                    label="Received On"
                                                    readonly
                                                    outlined
                                                    dense
                                                    hide-details
                                                    @change="getEnquiries"
                                                    v-on="on"
                                                >
                                                    <!-- append icon -->
                                                    <template v-slot:append>
                                                        <transition name="fade">
                                                            <v-btn v-if="dateRange" class="rpd-datepicker-btn mr-1" icon @click="dateRange = null"><v-icon>mdi-close</v-icon></v-btn>
                                                        </transition>
                                                        <v-btn class="rpd-datepicker-btn" icon v-on="on"><v-icon>mdi-calendar</v-icon></v-btn>
                                                    </template>
                                                </v-text-field>
                                            </template>
                                            <v-date-picker style="width: 100%;" 
                                                v-model="dateRange" 
                                                range
                                                persistent
                                            ></v-date-picker>
                                        </v-menu>
                                    </v-col>
                                </v-row>
                                <template v-if="tableType === 'company'">
                                    <v-row>
                                        <v-col cols="12">
                                            <v-autocomplete
                                                v-model="filters.companyFilter"
                                                :loading="companies.loading"
                                                :items="companies.items"
                                                :search-input.sync="companies.search"
                                                cache-items
                                                flat
                                                hide-no-data
                                                clearable
                                                outlined
                                                dense
                                                hide-details
                                                item-text="name"
                                                item-value="id"
                                                label="Company"
                                                @change="getEnquiries"
                                            ></v-autocomplete>

                                        </v-col>
                                    </v-row>
                                </template>
                                <template v-else>
                                    <v-row>
                                        <v-col cols="12">
                                            <v-autocomplete
                                                v-model="filters.landlord_agent_contact"
                                                :loading="landlord_agent_contacts.loading"
                                                :items="landlord_agent_contacts.items"
                                                :search-input.sync="landlord_agent_contacts.search"
                                                cache-items
                                                flat
                                                outlined
                                                dense
                                                hide-details
                                                
                                                :filter="() => true"
                                                clearable
                                                item-text="name"
                                                item-value="id"
                                                label="Landlord Agent Contact"
                                                placeholder="Search Landlord Agent Contact"
                                                v-validate="''"
                                                :error-messages="errors.collect('form.landlord_agent_contact')"
                                                data-vv-name="form.landlord_agent_contact"
                                                data-vv-as="LL Contact"
                                                persistent-hint
                                                @change="getEnquiries"
                                            ></v-autocomplete>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-autocomplete
                                                v-model="filters.schemeFilter"
                                                :loading="schemes.loading"
                                                :items="schemes.items"
                                                :search-input.sync="schemes.search"
                                                cache-items
                                                flat
                                                :hide-no-data="schemes.loading ? true : false"
                                                clearable
                                                hide-no-data
                                                outlined
                                                dense
                                                hide-details
                                                return-object
                                                :item-text="'name'"
                                                :item-title="item => item.name"
                                                :item-value="item => item.value"
                                                label="Scheme"
                                                @change="getEnquiries"
                                            ></v-autocomplete>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-autocomplete
                                                v-model="filters.propertyFilter"
                                                :loading="properties.loading"
                                                :items="properties.items"
                                                :search-input.sync="properties.search"
                                                :item-text="'label'"
                                                :hide-no-data="properties.loading ? true : false"
                                                return-object
                                                :item-title="item => item.label"
                                                :item-value="item => item.value"
                                                no-filter
                                                outlined
                                                dense
                                                hide-details
                                                clearable
                                                hide-no-data
                                                label="Property"
                                                @change="getEnquiries"

                                            ></v-autocomplete>
                                        </v-col>

                                        <!-- <v-col cols="12">
                                            <v-autocomplete
                                                v-model="filters.contact"
                                                :loading="contacts.loading"
                                                :items="contacts.items"
                                                :search-input.sync="contacts.search"
                                                cache-items
                                                flat
                                                hide-no-data
                                                clearable
                                                outlined
                                                dense
                                                hide-details
                                                item-text="name"
                                                item-value="id"
                                                label="Contact"
                                                @change="getEnquiries"
                                            ></v-autocomplete>
                                        </v-col> -->

                                         <v-col cols="6">
                                            <v-autocomplete
                                                v-model="filters.town"
                                                :items="towns.items"
                                                :search-input.sync="towns.search"
                                                cache-items
                                                flat
                                                outlined
                                                dense
                                                hide-details
                                                clearable
                                                label="Town"
                                                @change="getEnquiries"
                                            ></v-autocomplete>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-autocomplete
                                                v-model="filters.region"
                                                :items="regions.items"
                                                :search-input.sync="regions.search"
                                                cache-items
                                                flat
                                                outlined
                                                clearable
                                                dense
                                                hide-details
                                                label="Region"
                                                @change="getEnquiries"
                                            ></v-autocomplete>
                                        </v-col> 
                                    </v-row>

                                        <v-divider class="my-8"></v-divider>

                                    <h5 class="text-h7 mb-1 mt-2 pa-0">Property Size</h5>
                                    <v-row>
                                        
                                        <v-col cols="6">
                                            <v-text-field
                                                v-model="filters.size_from"
                                                label="Size From"
                                                outlined
                                                dense
                                                hide-details
                                                @change="getEnquiries"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-text-field
                                                v-model="filters.size_to"
                                                label="Size To"
                                                outlined
                                                dense
                                                hide-details
                                                @change="getEnquiries"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>

                                    <h5 class="text-h7 mb-1 mt-2 pa-0">Rent</h5>
                                    <v-row>
                                        <v-col cols="6">
                                            <currency-input
                                            ref="rentFrom"
                                            v-model="filters.rent_from"
                                            :validation="'decimal:2'"
                                            label="Rent From"
                                            :errorMsgs="errors.collect('filters.rent_from')"
                                        ></currency-input>
                                        </v-col>
                                        <v-col cols="6">
                                            <currency-input
                                                ref="rentTo"
                                                v-model="filters.rent_to"
                                                :validation="'decimal:2'"
                                                label="Rent To"
                                                :errorMsgs="errors.collect('filters.rent_to')"
                                            ></currency-input>
                                        </v-col>
                                    </v-row>

                                </template>
                                
                            </v-card-text>
                        </v-card>
                    </v-menu>
                        
                    
                <!-- <v-col cols="6" md="3">
                    <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                    ></v-text-field>
                </v-col> -->
            </v-row>
        </v-toolbar>
        
        <v-card-text class="pt-0">
            <!-- :sortBy.sync="enquiryByProperty.sortBy"
                :sortDesc.sync="enquiryByProperty.sortDesc"
                :items-per-page.sync="enquiryByProperty.itemsPerPage"
                :page.sync="enquiryByProperty.page" -->
            <v-data-table
                style="width:100%; border: 1px solid #e0e0e0; border-radius: 4px;"
                :headers="headers"
                :items="enquiries"
                :loading="loading"
                :server-items-length="totalRecords"
                :multi-sort="false"
                :footer-props="{'items-per-page-options': [50, 100, 500],}"
                :options.sync="options"
                class="elevation-0"
                @update:options="updateOptions"
            >

                <template v-slot:body="{ items }">
                    <tbody v-if="initLoader">
                        <tr v-for="n in 12" :key="n">
                            <td class="px-0 table-loading"  :colspan="headers.length">
                                <v-skeleton-loader
                                type="list-item"
                                ></v-skeleton-loader>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else-if="items.length > 0 && tableType == 'company'">
                        <tr v-for="item in items" :key="item.id">

                            <td>
                                <a v-if="item.company_id" @click="viewCompany(item.company_id)">
                                    {{ item.company_name }}
                                </a>
                            </td>
                            <td>{{ item.interest }}</td>
                            <td>{{ item.under_offer }}</td>
                            <td>{{ item.completed }}</td>
                            <td>{{ item.withdrawn }}</td>
                            <td style="text-align: center;">
                                <v-icon small @click="viewCompany(item.company_id, 'enquiries')">mdi-eye</v-icon>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else-if="items.length > 0 && tableType == 'property'">
                        <tr v-for="item in items" :key="item.id" class="data-table__row">
                            <td>{{ item.received_at }}</td>
                            <td>
                                <a v-if="item.property_id" @click="viewProperty(item.property_id)">
                                    {{ item.property.data.address.data.full_address }}
                                </a>
                            </td>
                            <td>
                                <a v-if="item.scheme_id" @click="viewScheme(item.scheme_id)">
                                    {{ item.scheme.data.name }}
                                </a>
                                <a v-else-if="item.property_id && item.property.data.scheme_id" @click="viewScheme(item.property.data.scheme_id)">
                                    {{ item.property.data.scheme.data.name }}
                                </a>
                            </td>
                            <td>
                                <a v-if="item.company_id" @click="viewCompany(item.company_id)">
                                    {{ item.company.data.name }}
                                </a>
                            </td>
                            <td>
                                <a v-if="item.user_id" @click="viewContact(item.user_id)">
                                    {{ item.user.data.name }}
                                </a>
                            </td>

                            <td>
                                <template v-if="item.property && item.property.data.landlord_agent_contacts">
                                    <a v-for="agent in item.property.data.landlord_agent_contacts.data" @click="viewContact(agent.id)" :key="agent.id">
                                        {{ agent.name }}<span v-if="item.property.data.landlord_agent_contacts.data.indexOf(agent) !== item.property.data.landlord_agent_contacts.data.length - 1">, </span>
                                        <!-- add comma if item is not last item in data -->
                                    </a>
                                </template>
                                <template v-else-if="item.scheme && item.scheme.data.landlord_agent_contacts">
                                    <a v-for="agent in item.scheme.data.landlord_agent_contacts.data" @click="viewContact(agent.id)" :key="agent.id">
                                        {{ agent.name }}<span v-if="item.scheme.data.landlord_agent_contacts.data.indexOf(agent) !== item.scheme.data.landlord_agent_contacts.data.length - 1">, </span>
                                        <!-- add comma if item is not last item in data -->
                                       
                                    </a>
                                </template>
                            </td>

                            <td>
                                <span v-if="item.property && item.property.data.address">{{ item.property.data.address.data.city }}</span>
                                <span v-else-if="item.scheme && item.scheme.data.address">{{ item.scheme.data.address.data.city }}</span>
                            </td>
                            <td>
                                <span v-if="item.property && item.property.data.address">{{ item.property.data.address.data.region }}</span>
                                <span v-else-if="item.scheme && item.scheme.data.address">{{ item.scheme.data.address.data.region }}</span>
                            </td>

                            <td style="text-transform: capitalize;">{{ formatData(item.reason) }}</td>
                            <td style="text-transform: capitalize;">{{ formatData(item.stage) }}</td>
                            
                            <!-- <td>{{ item.created_at }}</td>
                            <td>{{ item.updated_at }}</td> -->
                            <td class="text-center data-table__frozen-right">
                                <v-icon class="mx-1" small @click="editEnquiry(item)">mdi-pencil</v-icon>
                                <v-icon class="mx-1" small @click="deleteItem(item)">mdi-delete</v-icon>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td :colspan="headers.length" class="text-center">No records found</td>
                        </tr>
                    </tbody>
                </template>
            </v-data-table>
        </v-card-text>
        <add-enquiries-dialog ref="addEnquiriesDialog" @updated="getEnquiries"/>
        <edit-enquiry ref="editEnquiry" @edited="updatedEnquiry"/>
        <edit-scheme-dialog ref="editSchemeDialog" @edited="getEnquiries"/>
        <edit-property-dialog ref="editPropertyDialog" @edited="getEnquiries"/>
        <edit-company-dialog ref="editCompanyDialog" @edited="getEnquiries"/>
        <edit-user-dialog ref="editUserDialog" @edited="getEnquiries"/>
        <completed-wizard ref="completedWizard"></completed-wizard>
    </v-col>
</v-row>
</template>
<script>
import addEnquiriesDialog from '@/components/enquiries/addEnquiriesDialog'
import EditSchemeDialog from '@/components/schemes/editSchemeDialog'
import editEnquiry from '@/components/enquiries/editEnquiry';
import EditPropertyDialog from "@/components/properties/editPropertyDialog";
import EditCompanyDialog from "@/components/companies/editCompanyDialog";
import editUserDialog from '@/components/users/editUserDialog'
import completedWizard from '@/components/enquiries/completedWizard.vue';
import currencyInput from "@/components/common/currencyInput.vue";
import { property } from 'lodash';
import { filter } from 'lodash';
import { sortBy } from 'lodash';
export default {
    components: {
        addEnquiriesDialog,
        EditSchemeDialog,
        EditPropertyDialog,
        EditCompanyDialog,
        editEnquiry,
        editUserDialog,
        completedWizard,
        currencyInput
    },
    data() {
        return {
            enquiries: [],
            search: '',
            loading: false,
            initLoader: true,
            pagination: {},
            totalRecords: 0,
            tableType: 'company',
            records: [],
            dateRange: null,
            dateRangeText: '',
            hideWithdrawn: true,
            isExporting: false,

            options: {
                sortBy: [],
                sortDesc: [],
                itemsPerPage: 50,
                page: 1,
            },

            headers: [
                { text: 'Company', value: 'company_name', sortable: false },
                { text: 'Interest', value: 'interest', class:'data-table__cell'},
                { text: 'Under Offer', value: 'under_offer', class:'data-table__cell'},
                { text: 'Completed', value: 'completed', class:'data-table__cell'},
                { text: 'Withdrawn', value: 'withdrawn', class:'data-table__cell'},
                { text: 'Actions', value: 'actions', align: 'center', sortable: false }
            ],

            companyHeaders: [
                { text: 'Company', value: 'company_name' , sortable: false, class:'data-table__cell'},
                { text: 'Interest', value: 'interest', class:'data-table__cell'},
                { text: 'Under Offer', value: 'under_offer', class:'data-table__cell'},
                { text: 'Completed', value: 'completed', class:'data-table__cell'},
                { text: 'Withdrawn', value: 'withdrawn', class:'data-table__cell'},
                { text: 'Actions', value: 'actions', align: 'center', sortable: false }
            ],
            propertyHeaders: [
                { text: 'Received On', value: 'received_at', class:'data-table__cell'},
                { text: 'Address', value: 'property.id', class:'data-table__cell'},
                { text: 'Scheme', value: 'scheme.name' , class:'data-table__cell'},
                { text: 'Company', value: 'company.name', class:'data-table__cell'},
                { text: 'Enquiry Contact', value: 'user.name', class:'data-table__cell'},
                { text: 'Landlord Agent Contact', value: 'landlord_agent_contact.name', class:'data-table__cell', sortable: false},
                { text: 'Town', value: 'address_city', class:'data-table__cell', sortable: false},
                { text: 'Region', value: 'address_region', class:'data-table__cell', sortable: false},
                { text: 'Type', value: 'reason', class:'data-table__cell'},
                { text: 'Status', value: 'stage', class:'data-table__cell'},
                
                // { text: 'Created On', value: 'created_at', class:'data-table__cell'},
                // { text: 'Updated On', value: 'updated_at', class:'data-table__cell'},
                { text: 'Actions', value: 'actions', sortable: false, align: 'center', width: '100px' }  
            ],

            filtersMenu: false,
            filters: {
                landlord_agent_contact: null,

                schemeFilter: null,
                propertyFilter: null,
                companyFilter: null,

                town: null,
                region: null,
                contact: null,

                size_from: null,
                size_to: null,
                rent_from: null,
                rent_to: null,

                enquiryAgentContacts: [],
            },

            landlord_agent_contacts: {
                loading: false,
                items: [],
                search: '',
            },
            schemes: {
                loading: false,
                items: [],
                search: '',
            },
            properties: {
                loading: false,
                items: [],
                search: '',
            },
            companies: {
                loading: false,
                items: [],
                search: '',
            },
            contacts: {
                loading: false,
                items: [],
                search: '',
            },

            towns:{
                loading: false,
                items: [],
                search: '',
            },
            regions:{
                loading: false,
                items: [],
                search: '',
            },
            
        }
    },
    methods:{
        updateOptions(options) {
            if(this.tableType === 'company')
                return

            let enquiryOptions = {
                sortBy: options.sortBy,
                sortDesc: options.sortDesc,
                itemsPerPage: options.itemsPerPage,
                page: options.page,
            }

            this.enquiryByProperty = enquiryOptions
            this.getEnquiries()
        },

        updatedEnquiry(form, entity){
            this.getEnquiries()
            if(form.stage == 'completed'){
                this.$notify.question(`An enquiry has been completed, Would you like to create a new deal for this enquiry?`, () => {
                    this.$refs.completedWizard.openDialog(form, entity.property_id ? {label: '', value: entity.property_id} : null, entity.scheme_id ? {label: '', value: entity.scheme_id} : null)
                })
            }
        },

        getEnquiries(){
            if(this.tableType === 'company'){
                this.getEnquiriesByCompany()
            }else{
                this.getEnquiriesByProperty()
            }
        },

        getEnquiriesByCompany(){
            this.loading = true
            // this.enquiries = []
            this.$http.get('/enquiries/companies', {
                params: {
                    from_date: this.dateRange ? this.dateRange[0] : null,
                    to_date: this.dateRange ? this.dateRange[1] : null,
                    page: this.pagination.page,
                    company_id: this.filters.companyFilter ? this.filters.companyFilter : null,
                    per_page: this.pagination.itemsPerPage,
                    // sort_by: this.pagination.sortBy.length ? this.pagination.sortBy[0] : null,
                    // desc: this.pagination.sortDesc.length ? (this.pagination.sortDesc[0] ? 1 : 0) : null,
                }
            }).then(response => {
                this.enquiries = response.data
                this.totalRecords = response.data.total
                this.loading = false
                this.initLoader = false
            }).catch(error => {
                console.log(error)
                this.loading = false
                this.initLoader = false
            })
        },

        getEnquiriesByProperty(){
            this.loading = true
            // this.enquiries = []
            this.$http.get('/enquiries?include=scheme,scheme.address,company,user,property,property.address,scheme.address,property.scheme,stage,scheme.landlord_agent_contacts, property.landlord_agents', {
                params: {
                    from_date: this.dateRange ? this.dateRange[0] : null,
                    to_date: this.dateRange ? this.dateRange[1] : null,
                    property_id: this.filters.propertyFilter ? this.filters.propertyFilter.id : null,
                    scheme_id: this.filters.schemeFilter ? this.filters.schemeFilter.id : null,

                    address_city: this.filters.town,
                    address_region: this.filters.region,
                    contact: this.filters.contact ? this.filters.contact.id : null,
                    
                    size_from: this.filters.size_from,  
                    size_to: this.filters.size_to,
                    rent_from: this.filters.rent_from,
                    rent_to: this.filters.rent_to,
                    stage: this.hideWithdrawn ? ['interest', 'under_offer'] : null,
                    landlord_agent_contact_id: this.filters.landlord_agent_contact,

                    page: this.enquiryByProperty.page,
                    per_page: this.enquiryByProperty.itemsPerPage,
                    sort_by: this.enquiryByProperty.sortBy.length ? this.enquiryByProperty.sortBy[0] : null,
                    desc: this.enquiryByProperty.sortDesc.length ? (this.enquiryByProperty.sortDesc[0] ? 1 : 0) : null,
                }
            }).then(response => {
                // take every unique landlord agent contact id and create an array of them
                this.filters.enquiryAgentContacts = [...new Set(response.data.data.map(enquiry => {
                    if(enquiry.property && enquiry.property.data.landlord_agent_contacts){
                        return enquiry.property.data.landlord_agent_contacts.data.map(contact => contact.id)
                    }else if(enquiry.scheme && enquiry.scheme.data.landlord_agent_contacts){
                        return enquiry.scheme.data.landlord_agent_contacts.data.map(contact => contact.id)
                    }
                }).flat())]

                this.enquiries = response.data.data
                this.totalRecords = response.data.meta.pagination.total
                this.loading = false
                this.initLoader = false
            }).catch(error => {
                console.log(error)
                this.loading = false
                this.initLoader = false
            })
        },

        async getLandlordAgentContacts() {
            await this.$http.get('/users/', {
                params: {
                    q: this.landlord_agent_contacts.search,
                    per_page: 1000,
                }
            }).then(response => {
                // filter out the landlord agent contacts that are not in the enquiryAgentContacts array
                let data = response.data.data.filter(contact => this.filters.enquiryAgentContacts.includes(contact.id))
                this.landlord_agent_contacts.items = data
                this.landlord_agent_contacts.loading = false
            }).catch(error => {
                console.log(error)
                this.landlord_agent_contacts.loading = false
            })
        },

        async getSchemes() {
            await this.$http.get('/schemes/', {
                params: {
                    q: this.schemes.search,
                    per_page: 100,
                }
            }).then(response => {
                this.schemes.items = response.data.data
                this.schemes.loading = false
            }).catch(error => {
                console.log(error)
                this.schemes.loading = false
            })
            
        },

        async getCompanies() {
            await this.$http.get('/companies/', {
                params: {
                    q: this.companies.search,
                    per_page: 100,
                }
            }).then(response => {
                this.companies.items = response.data.data
                this.companies.loading = false
            }).catch(error => {
                console.log(error)
                this.companies.loading = false
            })
        },

        async getProperties() {
            await this.$http.get("/properties/simple",{
                params: {
                    q: this.properties.search,
                    per_page: 50,
                    include: 'address,tenant,scheme',
                }
            }).then(response => {
                // add label to each property, and set the label to be equal to the full address + unit number
                this.properties.items = response.data.data.map(property => {
                    let tenant = property.tenant.data.name ? property.tenant.data.name + ',' : 'Vacant,'
                    let unit = property.building_num ? property.building_num : ''
                    if(property.scheme_id){
                        property.label = `${tenant} ${unit} ${property.scheme.data.name}, ${property.address.data.full_address}`
                        return property
                    }else{
                        property.label = `${tenant} ${unit} ${property.address.data.full_address}`
                        return property
                    }
                })
                this.properties.loading = false                
            }).catch(error => {
                this.properties.loading = false
                console.log(error)
            })
        },

        getContacts() {
            this.$http.get('/users/', {
                params: {
                    q: this.contacts.search,
                    per_page: 100,
                }
            }).then(response => {
                this.contacts.items = response.data.data
                this.contacts.loading = false
            }).catch(error => {
                console.log(error)
                this.contacts.loading = false
            })
        },

        getAreas(){
            this.$http.get('/enquiries/cities', {
                }).then(response => {
                    this.towns.items = response.data
                    this.towns.loading = false
                }).catch(error => {
                    console.log(error)
                    this.towns.loading = false
                })
            this.$http.get('/enquiries/regions', {
                }).then(response => {
                    this.regions.items = response.data
                    this.regions.loading = false
                }).catch(error => {
                    console.log(error)
                    this.regions.loading = false
                })
        },

        deleteItem(item){
                this.$notify.question(`Are you sure you want to delete this enquiry?`, () => {
                    this.$http.delete(`/enquiries/${item.id}`).then(response => {
                        this.getEnquiries()
                        this.createDialog = false
                        this.editDialog = false
                    }).catch(error => {
                    })
                })
            },

        editEnquiry(enquiry){
            this.$refs.editEnquiry.openDialog(enquiry)
        },
        viewScheme(id) {
            this.$refs.editSchemeDialog.showDialog(id);
        },
        viewProperty(id) {
            this.$refs.editPropertyDialog.showDialog(id);
        },
        viewCompany(id, tab = null) {
            this.$refs.editCompanyDialog.showDialog(id, tab);
        },
        viewContact(id) {
            this.$refs.editUserDialog.showDialog(id);
        },

        exportTotals(){
            this.isExporting = true
            this.$http.get('/enquiries/totals-export', {
                // received on and company filter
                responseType: 'blob',
                params: {
                    from_date: this.dateRange ? this.dateRange[0] : null,
                    to_date: this.dateRange ? this.dateRange[1] : null,
                    company_id: this.filters.companyFilter ? this.filters.companyFilter.id : null,
                }
            }).then(response => {
                this.isExporting = false
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement('a');
                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'enquiries_totals.xlsx');
                document.body.appendChild(fileLink);
                fileLink.click();
            }).catch(error => {
                this.isExporting = false
                console.log(error)
            })
        },

        exportEnquiries(){
            this.isExporting = true
            this.$http.get('/enquiries/export', {
                responseType: 'blob',
                params: {
                    from_date: this.dateRange ? this.dateRange[0] : null,
                    to_date: this.dateRange ? this.dateRange[1] : null,
                    property_id: this.filters.propertyFilter ? this.filters.propertyFilter.id : null,
                    scheme_id: this.filters.schemeFilter ? this.filters.schemeFilter.id : null,
                    town: this.filters.town,
                    region: this.filters.region,
                    contact: this.filters.contact ? this.filters.contact.id : null,
                    size_from: this.filters.size_from,  
                    size_to: this.filters.size_to,
                    rent_from: this.filters.rent_from,
                    rent_to: this.filters.rent_to,
                    stage: this.hideWithdrawn ? ['interest', 'under_offer'] : null,
                    landlord_agent_contact_id: this.filters.landlord_agent_contact,
                }
            }).then(response => {
                this.isExporting = false
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement('a');
                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'enquiries.xlsx');
                document.body.appendChild(fileLink);
                fileLink.click();
            }).catch(error => {
                this.isExporting = false
                console.log(error)
            })
        },

        resetFilters() {
            this.filters = {
                schemeFilter: null,
                propertyFilter: null,
                companyFilter: null,

                town: null,
                region: null,
                contact: null,

                size_from: null,
                size_to: null,
                rent_from: null,
                rent_to: null,
            }
            this.dateRange = null
            this.dateRangeText = ''
            this.getEnquiries()
        },

        formatData(data){
            if(!data) return ''
            return data.replace(/_/g, ' ');
        },
        debounce(fn, delay) {
      
            clearTimeout(this._timerId)
            this._timerId = setTimeout(() => {
                fn();
            }, delay);
        },
    },
    mounted(){
        this.getAreas()
        this.getEnquiries()
    },
    computed: {
        filtersActive() {
            // exclude enquiryAgentContacts, landlord_agent_contact
            let filters = {...this.filters}
            delete filters.enquiryAgentContacts
            delete filters.landlord_agent_contact
            return Object.values(filters).some(filter => filter !== null && filter !== '')
        },

        enquiryByProperty: {
            get() {
                this.options = this.$store.state.options.enquiryByProperty
                return this.$store.state.options.enquiryByProperty
            },
            set(value) {
                this.$store.commit('setOptions', { key: 'enquiryByProperty', value: value })
            }
        },
    },
    watch: {
        search: function (val) {
            this.getEnquiries()
        },
        
        pagination: {
            handler() {
                this.getEnquiries()
            },
            deep: true
        },

        search() {
            clearTimeout(this._timerId)
            this._timerId = setTimeout(() => {
                this.page = 1
                this.getEnquiries()
            }, 500)
        },

        'landlord_agent_contacts.search': function(search) {
            this.landlord_agent_contacts.loading = true
            this.debounce(() => {
                this.getLandlordAgentContacts()
            }, 375)
        },

        'schemes.search': function(search) {
            if (!search) return;
            this.schemes.loading = true
            this.debounce(() => {
                this.getSchemes()
            }, 375)
        },
        'properties.search': function(search) {
            if (!search) return;
            this.properties.loading = true
            this.debounce(() => {
                this.getProperties()
            }, 375)
        },
        'companies.search': function(search) {
            if (!search) return;
            this.companies.loading = true
            this.debounce(() => {
                this.getCompanies()
            }, 375)
        },
        'contacts.search': function(search) {
            if (!search) return;
            this.contacts.loading = true
            this.debounce(() => {
                this.getContacts()
            }, 375)
        },

        'filters.rent_from': function() {
            this.getEnquiries()
        },

        'filters.rent_to': function() {
            this.getEnquiries()
        },

        page() {
            this.$vuetify.goTo(1)
        },
        
        showUnverified() {
            this.getEnquiries()
        },

        tableType(){
            this.initLoader = true
            if(this.tableType === 'company'){
                // this.sortBy = 'company_name'
                // this.pagination.sortBy[0] = '',
                this.getEnquiries()
                this.headers = this.companyHeaders
            }else{
                // this.sortBy = 'address_id'
                // this.pagination.sortBy[0] = '',
                this.getEnquiries()
                this.headers = this.propertyHeaders
            }
        },

        dateRange() {
            if (this.dateRange) {
                // format dates first from YYYY-MM-DD to DD/MM/YYYY
                let dates = this.dateRange.map(date => {
                    return date.split('-').reverse().join('/')
                })
                this.dateRangeText = dates.join(' - ')
                this.getEnquiries()
            } else {
                this.dateRangeText = ''
                this.getEnquiries()
            }
        },

        
    }

};
</script>

<style>



.fade-enter-active, .fade-leave-active {
    transition: opacity 0.25s;
}
.fade-enter, .fade-leave-to {
    opacity: 0;
}
</style>
